import { SETTING_OT_FETCHING, SETTING_OT_FAILED, SETTING_OT_SUCCESS } from "../actions/types";

const initialState = {
  result: null,
  isFetching: false,
  isError: false,
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case SETTING_OT_FETCHING:
      return { ...state, result: null, isFetching: true, isError: false };
    case SETTING_OT_FAILED:
      return { ...state, result: null, isFetching: false, isError: true };
    case SETTING_OT_SUCCESS:
      return { ...state, result: payload, isFetching: false, isError: false };
    default:
      return state;
  }
};
